import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {Order} from "../types.ts";

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: Order,
        handleSubmit: (values: Order) => void
    }) => {

    const title = record?.id ? `Edit Order` : `Add Order`;

    const handleFormSubmit = async (values: Order) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <Drawer
            transitionProps={{
                transition: "slide-left",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    )
};
